import { FC, useEffect, useState } from 'react';
import { useWxWork } from '@cloud/wxwork-workbench';
import BasicLayout from '@/layouts/basic';
import PageEntry from '@/components/PageEntry';
import { queryUnreadCounts } from './service';
import { launcherList } from './constants';
import styles from './index.less';


interface UnreadCounts {
  task: number;
  reminder: number;
  sop: number;
}

const defaultUnreadCounts = {
  task: 0,
  reminder: 0,
  sop: 0
};

const IndexPage: FC<{}> = () => {
  const [unreadCounts, setUnreadCounts] = useState<UnreadCounts>(defaultUnreadCounts);
  const signature = useWxWork();

  useEffect(() => {
    if (signature.corpId && signature.userId) {
      queryUnreadCounts(signature).then(setUnreadCounts);
    }
  }, [signature]);

  return (
    <BasicLayout>
      <div className={styles.launchpad}>
        {launcherList.map(p => <PageEntry key={p.name} {...p} getUnreadCount={n => unreadCounts[n]} />)}
      </div>
    </BasicLayout>
  )
};

export default IndexPage;